import React from 'react';

import { TextField } from '@crehana/ui';

import { useTranslation } from '@crehana/i18n';

import { CheckNew } from '@crehana/icons';

type CouponFieldProps = {
  className?: string;
  couponApplied: boolean;
  onApplyCoupon: () => void;
  couponCode: string;
  couponErrorMessage: string;
  onChangeCoupon: (event: React.ChangeEvent<HTMLInputElement>) => void;
  couponValidate: boolean;
  onRemoveCoupon: () => void;
  isPristine: boolean;
  onKeyPressEnter: (event: React.KeyboardEvent<HTMLInputElement>) => void;
};

const CouponField: React.FC<CouponFieldProps> = ({
  className,
  couponApplied,
  onApplyCoupon,
  couponCode,
  couponErrorMessage,
  onChangeCoupon,
  couponValidate,
  onRemoveCoupon,
  isPristine,
  onKeyPressEnter,
}) => {
  const { t } = useTranslation();
  const [showCoupon, setShowCoupon] = React.useState<boolean>(!!couponCode);

  return (
    <div
      className={className}
      onKeyPress={event => {
        // @ts-expect-error
        onKeyPressEnter(event);
      }}
      data-testid="coupon"
    >
      <button
        className="font-link text-secondary-main"
        type="button"
        onClick={() => {
          setShowCoupon(!showCoupon);
          if (couponApplied) {
            onRemoveCoupon();
          }
        }}
      >
        {t('COUPON_TITLE')}
      </button>
      {showCoupon && (
        <div className="mt-12">
          <div className="block mb-16">
            {couponApplied ? (
              <p className="flex font-body3">
                <span className="mr-12"> {couponCode} </span>
                <CheckNew
                  size={20}
                  ignoreColor
                  className="fill-current text-secondary-main"
                />
              </p>
            ) : (
              <TextField
                full
                errorText={couponErrorMessage}
                autoFocus
                error={!!couponErrorMessage}
                onChange={onChangeCoupon}
                value={couponCode}
                check={couponValidate}
                wrapperClassName="bg-white"
                data-testid="coupon-code-field"
                label={t('COUPON_LABEL')}
              />
            )}
          </div>
          {couponApplied ? (
            <div className="block">
              <button
                type="button"
                onClick={onRemoveCoupon}
                data-testid="remove-coupon-button"
                className={`font-link  ${
                  couponCode ? 'text-primary-main' : 'text-gray-dark'
                }`}
              >
                Remover
              </button>
            </div>
          ) : (
            <div className="flex justify-center ">
              <button
                className={`font-link  ${
                  couponCode ? 'text-secondary-main' : 'text-gray-dark'
                }`}
                disabled={!!couponErrorMessage || isPristine || !couponCode}
                onClick={onApplyCoupon}
                data-testid="apply-coupon-button"
                type="button"
              >
                {t('COUPON_BUTTON_LABEL')}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CouponField;
